import { EndReasonCategory } from '@debbie/common/dist/end-reasons/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { Select } from '../index.js';
// The one home for how end reason categories are presented — the settings
// pages and the end-case picker all read from here.
export const CATEGORY_ORDER = [
    EndReasonCategory.Success,
    EndReasonCategory.NotPossible,
    EndReasonCategory.Unresolved,
    EndReasonCategory.Error,
];
// Brand palette colors: salviegrøn, mauve, ler, turkis.
export const CATEGORY_COLOR = {
    [EndReasonCategory.Success]: '#6FAE8C',
    [EndReasonCategory.Unresolved]: '#C18A63',
    [EndReasonCategory.NotPossible]: '#B57F9E',
    [EndReasonCategory.Error]: '#4F9DAD',
};
export const CategoryBadge = styled.span `
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 0.8em;
  background: ${(p) => p.$color}22;
  color: ${(p) => p.$color};
  font-weight: 500;
`;
export const CategorySelect = (props) => {
    const lang = useSelector((s) => s.lang);
    return (React.createElement(Select, { value: props.value ?? '', onChange: (e) => props.onChange(e.target.value === '' ? null : e.target.value) },
        React.createElement("option", { value: "", disabled: true }, lang.endReasonsSettings.categoryPlaceholder),
        CATEGORY_ORDER.map((category) => (React.createElement("option", { key: category, value: category }, lang.endReasonCategory[category])))));
};
//# sourceMappingURL=categories.js.map